import { useEffect } from 'react';
import LoadingSpinner from '../../utils/LoadingSpinner';
import { useNavigate } from 'react-router-dom';
import { Auth } from 'aws-amplify';

const AuthComponent = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const initiateAuth = async () => {
      try {
        const session = await Auth.currentSession();
        if (session.isValid()) {
          navigate('/home');
          return;
        }
      } catch (error) {
        try {
          await Auth.federatedSignIn({
            provider: 'COGNITO'
          });
        } catch (error) {
          console.error('Failed to initiate SSO:', error);
          navigate('/login', { 
            state: { error: 'Failed to initiate authentication. Please try again.' } 
          });
        }
      }
    };

    initiateAuth();
  }, [navigate]);

  return <LoadingSpinner show={true} absolutePosition={false} />;
};

export default AuthComponent;